import { Component, OnInit } from '@angular/core';
import { SitesService } from '../../../services/sites.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-site-view',
  templateUrl: './site-view.component.html',
  styleUrls: ['./site-view.component.css']
})
export class SiteViewComponent implements OnInit {
  id;
  sub;
  loading: boolean = true;
  site;


  constructor(private sitesService: SitesService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
      console.log('if', this.id);
      this.sitesService.getSite(this.id).subscribe(site => {
        console.log('got site', site);
        this.site = site[0];
        this.loading = false;
      })
    })
 }
}
